import { cookieDecryption, cookieEncryption, onBoardingHandler, removeCookie, stepsObjectMaker } from '../../utils';
import { safeWindowLocation } from '../../utils/safeNavigation';
import axiosClient from '../../api/axiosClient';
import Cookies from 'js-cookie';
import store from '../../rematch';

const onBoardingModel = {
  state: {
    onboardingSteps: {
      userObj: {},
      additionalInfo: {},
      answerByMentors: {},
    },
    stateList: [],
    schoolOrInstitute: [],
    schoolOrInstitute_label: [],
    stepsFormData: {
      basicSteps: [],
      questionSchema: null,
      formatedData: [],
    },
    isSaveClicked: false,
    isProfilePic: false,
  },
  reducers: {
    setData(state, payload) {
      return {
        ...state,
        [payload.name]: payload.data,
      };
    },
  },
  effects: dispatch => ({
    async addOnboardingStep1({ payload, handleNavigate }, state) {
      await axiosClient
        .post('auth/updateUserBasicInfo', payload)
        .then(res => {
          if (res.data.code === 200) {
            let auth = cookieDecryption('userDetails');
            auth = {
              ...auth,
              onboardingStep: 2,
              userObj: { ...auth.userObj, onboardingStep: 2 },
            };
            cookieEncryption('userDetails', auth);
            dispatch.authModel.setUserDetails({
              name: 'logInUser',
              data: { ...state.authModel.logInUser, onboardingStep: 2 },
            });
            this.setData({
              name: 'onboardingSteps',
              data: {
                ...state.onBoardingModel.onboardingSteps,
                userObj: {
                  ...state.onBoardingModel.onboardingSteps.userObj,
                  onboardingStep: 2,
                },
              },
            });
            handleNavigate(onBoardingHandler(2));
          } else {
            dispatch.toastModel.showToast({
              value: 'Danger',
              message: res.data.msg,
            });
          }
        })
        .catch(err => {
          dispatch.toastModel.showToast({
            value: 'Danger',
            message: err.message,
          });
        });
    },
    async addOnboardingStep1Exit({ payload, handleNavigate }, state) {
      await axiosClient
        .post('auth/updateUserBasicInfo', payload)
        .then(res => {
          if (res.data.code === 200) {
            // Perform backend logout to obtain optional SLO URL
            return axiosClient.get('auth/log-out').then(resp => {
              const data = resp.data;
              Cookies.remove('userDetails');
              // EC-37 follow-up: validate API-provided SLO URL before navigation.
              const navigated =
                data?.data?.sloLogoutUrl && !data?.error && safeWindowLocation(data.data.sloLogoutUrl, 'assign');
              if (!navigated) {
                handleNavigate('/');
              }
            });
          } else {
            dispatch.toastModel.showToast({
              value: 'Danger',
              message: res.data.msg,
            });
          }
        })
        .catch(err => {
          dispatch.toastModel.showToast({
            value: 'Danger',
            message: err.message,
          });
        })
        .finally(() => {
          this.setData({ name: 'isSaveClicked', data: false });
        });
    },
    async addOnboardingStep2({ payload, handleNavigate }, state) {
      await axiosClient
        .post('auth/updateOnboardingDetails', payload)
        .then(res => {
          if (res.data.code === 200) {
            let auth = cookieDecryption('userDetails');
            auth = {
              ...auth,
              onboardingStep: 3,
              userObj: { ...auth.userObj, onboardingStep: 3 },
            };
            cookieEncryption('userDetails', auth);
            dispatch.authModel.setUserDetails({
              name: 'logInUser',
              data: { ...state.authModel.logInUser, onboardingStep: 3 },
            });
            this.setData({
              name: 'onboardingSteps',
              data: {
                ...state.onBoardingModel.onboardingSteps,
                userObj: {
                  ...state.onBoardingModel.onboardingSteps.userObj,
                  onboardingStep: 3,
                },
              },
            });
            handleNavigate(onBoardingHandler(3));
          } else {
            dispatch.toastModel.showToast({
              value: 'Danger',
              message: res.data.msg,
            });
          }
        })
        .catch(err => {
          dispatch.toastModel.showToast({
            value: 'Danger',
            message: err.message,
          });
        });
    },
    async addOnboardingStep2Exit({ payload, handleNavigate }, state) {
      await axiosClient
        .post('auth/updateOnboardingDetails', payload)
        .then(res => {
          if (res.data.code === 200) {
            return axiosClient.get('auth/log-out').then(resp => {
              const data = resp.data;
              Cookies.remove('userDetails');
              // EC-37 follow-up: validate API-provided SLO URL before navigation.
              const navigated =
                data?.data?.sloLogoutUrl && !data?.error && safeWindowLocation(data.data.sloLogoutUrl, 'assign');
              if (!navigated) {
                handleNavigate('/');
              }
            });
          } else {
            dispatch.toastModel.showToast({
              value: 'Danger',
              message: res.data.msg,
            });
          }
        })
        .catch(err => {
          dispatch.toastModel.showToast({
            value: 'Danger',
            message: err.message,
          });
        })
        .finally(() => {
          this.setData({ name: 'isSaveClicked', data: false });
        });
    },
    async addOnboardingStep3({ payload, handleNavigate }, state) {
      await axiosClient
        .post('auth/updateOnboardingDetails', payload)
        .then(res => {
          if (res.data.code === 200) {
            let auth = cookieDecryption('userDetails');
            auth = {
              ...auth,
              onboardingStep: 4,
              userObj: { ...auth.userObj, onboardingStep: 4 },
            };
            cookieEncryption('userDetails', auth);
            dispatch.authModel.setUserDetails({
              name: 'logInUser',
              data: { ...state.authModel.logInUser, onboardingStep: 4 },
            });
            this.setData({
              name: 'onboardingSteps',
              data: {
                ...state.onBoardingModel.onboardingSteps,
                userObj: {
                  ...state.onBoardingModel.onboardingSteps.userObj,
                  onboardingStep: 4,
                },
              },
            });
            handleNavigate(onBoardingHandler(4));
          } else {
            dispatch.toastModel.showToast({
              value: 'Danger',
              message: res.data.msg,
            });
          }
        })
        .catch(err => {
          dispatch.toastModel.showToast({
            value: 'Danger',
            message: err.message,
          });
        });
    },
    async addOnboardingStep3Exit({ payload, handleNavigate }, state) {
      await axiosClient
        .post('auth/updateOnboardingDetails', payload)
        .then(res => {
          if (res.data.code === 200) {
            return axiosClient.get('auth/log-out').then(resp => {
              const data = resp.data;
              Cookies.remove('userDetails');
              // EC-37 follow-up: validate API-provided SLO URL before navigation.
              const navigated =
                data?.data?.sloLogoutUrl && !data?.error && safeWindowLocation(data.data.sloLogoutUrl, 'assign');
              if (!navigated) {
                handleNavigate('/');
              }
            });
          } else {
            dispatch.toastModel.showToast({
              value: 'Danger',
              message: res.data.msg,
            });
          }
        })
        .catch(err => {
          dispatch.toastModel.showToast({
            value: 'Danger',
            message: err.message,
          });
        })
        .finally(() => {
          this.setData({ name: 'isSaveClicked', data: false });
        });
    },
    async uploadUserProfilePic({ payload }) {
      const formData = new FormData();
      formData.append('mentorProfilePic', payload?.mentorProfilePic);
      formData.append('mentorId', payload?.mentorId);
      axiosClient
        .post('auth/uploadUserProfilePic', formData)
        .then(res => {
          if (res.status === 200) {
            if (res?.data?.code === 200) {
            } else {
              dispatch.toastModel.showToast({
                value: 'Danger',
                message: res?.data?.msg,
              });
            }
          }
        })
        .catch(err => {
          dispatch.toastModel.showToast({
            value: 'Danger',
            message: 'Invalid Upload',
          });
        });
    },
    async getMatchingQuestion({ payload }, state) {
      await axiosClient
        .post('mentor/questionList', payload)
        .then(res => {
          if (!res.data?.error) {
            const auth = cookieDecryption('userDetails');
            const { result, schemaObject, formatedData } = stepsObjectMaker({
              data: res.data.data.finalResponse,
              categorySequence: res.data.data.categorySequence,
              role: auth.role,
            });
            const payload = {
              basicSteps: result,
              questionSchema: schemaObject,
              formatedData,
            };
            this.setData({ name: 'stepsFormData', data: payload });
          } else {
            dispatch.toastModel.showToast({
              value: 'Danger',
              message: res.data.msg,
            });
          }
        })
        .catch(err => {
          dispatch.toastModel.showToast({
            value: 'Danger',
            message: err.message,
          });
        });
    },
    async getStateData() {
      await axiosClient
        .get('auth/getStateList')
        .then(res => {
          if (res.data.code === 200) {
            let states = (res?.data?.data || []).reduce((acc, cur) => {
              return [...acc, { label: cur, value: cur }];
            }, []);
            this.setData({ name: 'stateList', data: states });
          } else {
            dispatch.toastModel.showToast({
              value: 'Danger',
              message: res.data.msg,
            });
          }
        })
        .catch(err => {
          dispatch.toastModel.showToast({
            value: 'Danger',
            message: err.message,
          });
        });
    },
    async getSchoolOrInstitute({ payload, setschool, listValue }) {
      await axiosClient
        .post('auth/schoolOrInstituteList', payload)
        .then(res => {
          if (res.data.code === 200) {
            let schoolOrInstituteLabel = (res?.data?.data?.SchoolOrInstitute || []).reduce((acc, cur) => {
              return [...acc, { label: cur, value: cur }];
            }, []);
            const schoolOrInstitute = (res?.data?.data?.SchoolOrInstitute || []).sort((a, b) => a.localeCompare(b));
            this.setData({
              name: 'schoolOrInstitute_label',
              data: schoolOrInstituteLabel,
            });
            this.setData({
              name: 'schoolOrInstitute',
              data: res?.data?.data?.SchoolOrInstitute,
            });
            if (setschool) {
              const filteredOptions = res?.data?.data?.SchoolOrInstitute.filter(item => !listValue.includes(item));
              setschool(filteredOptions);
            }
          } else {
            dispatch.toastModel.showToast({
              value: 'Danger',
              message: res.data.msg,
            });
          }
        })
        .catch(err => {
          dispatch.toastModel.showToast({
            value: 'Danger',
            message: err.message,
          });
        });
    },
    async updateSignUp({ handleNavigate, isExit }) {
      await axiosClient
        .get('auth/completeRegistration')
        .then(res => {
          if (res.data.code === 200) {
            if (isExit) {
              // Logout to propagate SLO when exiting
              return axiosClient.get('auth/log-out').then(resp => {
                const data = resp.data;
                removeCookie('userDetails');
                // EC-37 follow-up: validate API-provided SLO URL before navigation.
                const navigated =
                  data?.data?.sloLogoutUrl && !data?.error && safeWindowLocation(data.data.sloLogoutUrl, 'assign');
                if (!navigated) {
                  handleNavigate('/');
                }
              });
            } else {
              handleNavigate('/basic-info');
            }
          } else {
            dispatch.toastModel.showToast({
              value: 'Danger',
              message: res.data.msg,
            });
          }
        })
        .catch(err => {
          dispatch.toastModel.showToast({
            value: 'Danger',
            message: err.message,
          });
        });
    },
    async exitSignUp({ handleNavigate, isExit }) {
      await axiosClient
        .get('auth/completeRegistration')
        .then(res => {
          if (res.data.code === 200) {
            if (isExit) {
              return axiosClient.get('auth/log-out').then(resp => {
                const data = resp.data;
                removeCookie('userDetails');
                // EC-37 follow-up: validate API-provided SLO URL before navigation.
                const navigated =
                  data?.data?.sloLogoutUrl && !data?.error && safeWindowLocation(data.data.sloLogoutUrl, 'assign');
                if (!navigated) {
                  handleNavigate('/');
                }
              });
            } else {
              handleNavigate('/basic-info');
            }
          } else {
            dispatch.toastModel.showToast({
              value: 'Danger',
              message: res.data.msg,
            });
          }
        })
        .catch(err => {
          dispatch.toastModel.showToast({
            value: 'Danger',
            message: err.message,
          });
        });
    },
    // Returns true when navigation was triggered (completion succeeded, or
    // the server demoted the user to an earlier onboarding step), so callers
    // know whether to re-enable their submit UI.
    async applicationComplete({ handleNavigate, isExit }) {
      return await axiosClient
        .get('auth/applicationComplete')
        .then(async res => {
          if (res.data.code === 200) {
            // Best-effort refresh: completion already succeeded server-side,
            // so a failed getUserDetails must not block the step-5 updates
            // and navigation below.
            try {
              await dispatch.authModel.getUserDetails({});
            } catch {
              // Fall back to the existing cookie/store data.
            }
            let auth = cookieDecryption('userDetails');
            auth = {
              ...auth,
              onboardingStep: 5,
              userObj: { ...auth.userObj, onboardingStep: 5 },
            };
            cookieEncryption('userDetails', auth);
            // Re-read state after getUserDetails so we overlay onboardingStep
            // on the freshly fetched data instead of the pre-fetch snapshot.
            const freshState = store.getState();
            dispatch.authModel.setUserDetails({
              name: 'logInUser',
              data: { ...freshState.authModel.logInUser, onboardingStep: 5 },
            });
            this.setData({
              name: 'onboardingSteps',
              data: {
                ...freshState.onBoardingModel.onboardingSteps,
                userObj: {
                  ...freshState.onBoardingModel.onboardingSteps.userObj,
                  onboardingStep: 5,
                },
              },
            });
            handleNavigate('/home');
            return true;
          } else {
            dispatch.toastModel.showToast({
              value: 'Danger',
              message: res.data.msg,
            });
            // The server may have demoted the user (e.g. empty matching
            // answers send them back to Step 3). Routing reads the cookie, so
            // refresh it from the server and route to the step it reports;
            // otherwise the user is stuck on /application-complete where
            // Continue keeps failing.
            try {
              await dispatch.authModel.getUserDetails({});
            } catch {
              // Keep the existing cookie; we stay on this page below.
            }
            const auth = cookieDecryption('userDetails');
            const onboardingStep =
              auth?.onboardingStep === 0 ? auth?.onboardingStep : auth?.onboardingStep || auth?.userObj?.onboardingStep;
            if (onboardingStep !== undefined && onboardingStep !== 4) {
              handleNavigate(onBoardingHandler(onboardingStep));
              return true;
            }
            return false;
          }
        })
        .catch(err => {
          dispatch.toastModel.showToast({
            value: 'Danger',
            message: err.message,
          });
          return false;
        });
    },
    async addNewSchoolOrInstituteInApp({ payload }) {
      return axiosClient
        .post('auth/addNewSchoolOrInstituteInApp', payload)
        .then(res => {
          if (res.data.code === 200) {
          }
        })
        .catch(err => console.log(err));
    },
    async getAllSchoolOrInstitute() {
      return axiosClient
        .get('auth/all/schoolOrInstituteList')
        .then(res => {
          if (res.data.code === 200) {
            this.setData({
              name: 'schoolOrInstitute',
              data: res?.data?.data,
            });
          }
        })
        .catch(err => console.log(err));
    },
  }),
};

export default onBoardingModel;
